/* Soul Kofi Theme JS */

// ── CART DRAWER ──
const cartOverlay = document.getElementById('cart-overlay');
const cartDrawer = document.getElementById('cart-drawer');

function openCart() {
  cartDrawer.classList.add('active');
  cartOverlay.classList.add('active');
  document.body.style.overflow = 'hidden';
  refreshCart();
}

function closeCart() {
  cartDrawer.classList.remove('active');
  cartOverlay.classList.remove('active');
  document.body.style.overflow = '';
}

cartOverlay && cartOverlay.addEventListener('click', closeCart);
document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));

// ── FETCH & RENDER CART ──
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
  } catch(e) { console.error('Cart fetch error', e); }
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function renderCart(cart) {
  const itemsEl = document.getElementById('cart-items');
  const footerEl = document.getElementById('cart-footer');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = `<div class="cart-empty">
      <p>Your cart is empty.</p>
      <a href="/collections/all" class="btn-primary" onclick="closeCart()">Shop Now</a>
    </div>`;
    footerEl && (footerEl.style.display = 'none');
    return;
  }

  footerEl && (footerEl.style.display = 'block');
  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item__image" src="${item.image}" alt="${item.product_title}">
      <div class="cart-item__info">
        <div>
          <div class="cart-item__name">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        </div>
        <div class="cart-item__actions">
          <div class="cart-item__qty">
            <button onclick="updateQty('${item.key}', ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="updateQty('${item.key}', ${item.quantity + 1})">+</button>
          </div>
          <div class="cart-item__price">${formatMoney(item.line_price)}</div>
        </div>
        <button class="cart-item__remove" onclick="updateQty('${item.key}', 0)">Remove</button>
      </div>
    </div>
  `).join('');

  const subtotalEl = document.getElementById('cart-subtotal-price');
  subtotalEl && (subtotalEl.textContent = formatMoney(cart.total_price));
}

async function updateQty(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  refreshCart();
}

async function addToCart(variantId, qty = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (res.ok) { refreshCart(); openCart(); }
  } catch(e) { console.error('Add to cart error', e); }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── VARIANT SELECTOR ──
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    const group = this.closest('.variant-options');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');

    const variantId = this.dataset.variantId;
    const price = this.dataset.price;
    const available = this.dataset.available === 'true';

    const priceEl = document.querySelector('.product-page__price');
    if (priceEl && price) priceEl.textContent = '$' + (parseInt(price) / 100).toFixed(2);

    const atcBtn = document.querySelector('.add-to-cart-btn');
    if (atcBtn) {
      atcBtn.dataset.variantId = variantId;
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  });
});

// ── ADD TO CART BUTTON ──
document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    const variantId = this.dataset.variantId;
    if (variantId) addToCart(variantId);
  });
});

// ── INIT ──
document.addEventListener('DOMContentLoaded', () => {
  refreshCart();
});
